/* eslint-disable no-case-declarations */
import type { MediaFilter } from '../../types';

import type { AllActions } from './actions';

export interface State {
  internalName: string;
  mediaCentreSelectedFilters: MediaFilter[];
  languageToggle: boolean;
}

export const defaultState: State = {
  internalName: '',
  mediaCentreSelectedFilters: [],
  languageToggle: true,
};

const isFiltersEqual = (a: MediaFilter, b: MediaFilter): boolean => a.value === b.value;

export const rootReducer = (state: State, action: AllActions): State => {
  switch (action.type) {
    case 'clearMediaCentreFilters':
      return { ...state, mediaCentreSelectedFilters: [] };

    case 'resetState':
      return defaultState;

    case 'toggleMediaCentreSelectedFilter':
      const { filter } = action.payload;

      const remaining = state.mediaCentreSelectedFilters.filter((f) => !isFiltersEqual(filter, f));
      const nextFilters = remaining.length === state.mediaCentreSelectedFilters.length
        ? [...state.mediaCentreSelectedFilters, filter]
        : remaining;

      return { ...state, mediaCentreSelectedFilters: nextFilters };

    case 'updateInternalName':
      return { ...state, internalName: action.payload.internalName };

    case 'updateLanguageToggle':
      return { ...state, languageToggle: !!action.payload.languageToggle };

    default:
      return state;
  }
};
